import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=48ee32ec&scoped=true&"
import script from "./spinner.vue?vue&type=script&lang=js&"
export * from "./spinner.vue?vue&type=script&lang=js&"
import style0 from "./spinner.vue?vue&type=style&index=0&id=48ee32ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ee32ec",
  null
  
)

export default component.exports